<template>
  <div class="flex size-full flex-col items-center px-4 md:max-w-7xl md:px-5 lg:px-10">
    <div class="mb-3 flex w-full items-center">
      <p class="mb-2 flex flex-col self-start text-xl text-gray-700 md:text-2xl lg:text-3xl">
        <span>Restricciones de destino</span>
      </p>
    </div>
    <div class="flex w-full flex-col rounded-md bg-white p-2 md:p-4">
      <div class="flex w-full items-center text-sm md:text-base">
        <template
          v-for="(label, key) in tabs"
          :key="key"
        >
          <button
            class="flex shrink-0 items-center border-b-2 pb-3 pt-1"
            :class="{ 'border-gray-300': currentTab !== key, 'border-lk-green': currentTab === key }"
            @click="setCurrentTab(key)"
          >
            <span class="mr-1">{{ label }}</span>
            <span class="mr-4">({{ getTabCount(key) }})</span>
          </button>
        </template>
        <div class="w-full self-end border-b-2 border-gray-300" />
      </div>
      <lokal-loading
        v-if="isLoadingMakerConstrains || isLoadingProductsWithConstrains"
        :loading="isLoadingMakerConstrains || isLoadingProductsWithConstrains"
        class="mt-2 md:mt-4"
      />
      <div
        v-else
        class="mt-2 md:mt-4"
      >
        <template v-if="currentTab === 'maker' && makerConstrains?.length">
          <div class="mb-6">
            <maker-destination-constrain-table :destination-constrains="makerConstrains ?? []" />
          </div>
        </template>
        <template v-else-if="currentTab === 'product' && productsWithConstrains?.length">
          <maker-destination-constrains-product-list :products="productsWithConstrains" />
        </template>
        <p
          v-else
          class="py-10 text-center text-gray-400"
        >
          No hay restricciones de destino registradas.
        </p>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { useQuery } from 'vue-query';
import destinationConstrainsApi from 'api/destination-constrains';
import MakerDestinationConstrainTable from './maker-destination-constrains-table.vue';
import MakerDestinationConstrainsProductList from './maker-destination-constrains-product-list.vue';

const props = defineProps<{ makerId: number }>();
const tabs = { maker: 'Generales', product: 'Por producto' };
const currentTab = ref('maker');

const { data: productsWithConstrains, isLoading: isLoadingProductsWithConstrains } = useQuery(
  ['makerProducts', props.makerId],
  () => destinationConstrainsApi.makerProducts(props.makerId),
  {
    select: (response) => response.data.products,
  },
);

const { data: makerConstrains, isLoading: isLoadingMakerConstrains } = useQuery(
  ['makerConstrains', props.makerId],
  () => destinationConstrainsApi.makerConstrains(props.makerId),
  {
    select: (response) => response.data.destinationConstrains as DestinationConstrain[],
  },
);

function setCurrentTab(key: string) {
  currentTab.value = key;
}

function getTabCount(key: string) {
  if (key === 'maker') return makerConstrains.value?.length;
  if (key === 'product') return productsWithConstrains.value?.length;
  return 0;
}
</script>
